import React, { useEffect, useState } from "react";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import { FormValidate } from "../../../components/formValidate";
import {
  admin_challenge_opportunity_create,
  get_market_analysis_list,
} from "../admin.api";
import "./view.css";

let required = [
  "market_analysis_opportunity_id",
  "title",
  "description",
  "due_date",
];

export default function AddChallengeOpportunity(props) {
  const [formData, setFormData] = useState({});
  const [marketOpportunities, setMarketOpportunities] = useState([]);
  const [snackMessage, setSnackMessage] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const toDdMmYyyy = (yyyyMmDd) => {
    if (!yyyyMmDd) return "";
    const [year, month, day] = String(yyyyMmDd).split("-");
    if (!year || !month || !day) return "";
    return `${day}-${month}-${year}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files?.[0];

    if (file) {
      const limitMb = name === "image" ? 2 : 5;
      const maxSize = limitMb * 1024 * 1024;
      if (file.size > maxSize) {
        setSnackMessage(`File size must be less than ${limitMb}MB. Current size: ${(file.size / 1024 / 1024).toFixed(2)}MB`);
        setIsSnackError(true);
        setSnackOpen(true);
        // Clear the file input
        e.target.value = '';
        return;
      }
    }

    setFormData((prev) => ({ ...prev, [name]: file }));
  };

  const handleLoadMarketAnalysisOpportunities = async () => {
    try {
      const res = await get_market_analysis_list();
      setMarketOpportunities(Array.isArray(res) ? res : []);
    } catch (error) {
      setMarketOpportunities([]);
    }
  };

  useEffect(() => {
    handleLoadMarketAnalysisOpportunities();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = FormValidate(formData, required);
    setIsActive(true);
    if (Object.keys(errors).length === 0) {
      const form = new FormData();
      if (formData?.market_analysis_opportunity_id !== undefined && formData?.market_analysis_opportunity_id !== null && formData?.market_analysis_opportunity_id !== "") {
        form.append("market_analysis_opportunity_id", formData.market_analysis_opportunity_id);
      }
      if (formData?.title) {
        form.append("title", formData.title);
      }
      if (formData?.description) {
        form.append("description", formData.description);
      }
      if (formData?.site_url) {
        form.append("site_url", formData.site_url);
      }
      if (formData?.due_date) {
        form.append("due_date", toDdMmYyyy(formData.due_date));
      }
      if (formData?.brochure) {
        form.append("brochure", formData.brochure);
      }
      if (formData?.image) {
        form.append("image", formData.image);
      }

      admin_challenge_opportunity_create(form)
        .then((res) => {
          setSnackMessage(res.message);
          setIsSnackError(false);
          setSnackOpen(true);
          setIsActive(false);
        })
        .catch((error) => {
          setSnackMessage(
            error?.response?.data?.message || error?.message || "Create failed"
          );
          setIsSnackError(true);
          setSnackOpen(true);
          setIsActive(false);
        });
    } else {
      setSnackMessage("Please fill all mandatory fields");
      setIsSnackError(true);
      setSnackOpen(true);
      setIsActive(false);
    }
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/challenges");
    }
  };

  return (
    <div className="add-per">
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <Loader open={isActive} />
      <div className="view-container">
        <div className="d-flex justify-content-between align-items-center">
          <h6>
            <b>Add Challenges</b>
          </h6>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={(e) => {
              props.history.push("/challenges");
            }}
          >
            Back
          </button>
        </div>

        <hr />
        <div className="row">
          <div className="col-12">
            <label className="control-label mylabel" htmlFor="market_analysis_opportunity_id">
              Market Analysis Opportunity
              <span className="required-asterisk">*</span>
            </label>
            <div className="mandatory input-group">
              <select
                className="form-control mb-2"
                name="market_analysis_opportunity_id"
                id="market_analysis_opportunity_id"
                value={formData?.market_analysis_opportunity_id ?? ""}
                onChange={handleChange}
              >
                <option value="">Select</option>
                {marketOpportunities.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.opportunity}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-12">
            <TextField
              fullwidth
              label="Title"
              value={formData?.title ?? ""}
              onChange={handleChange}
              name="title"
              id="title"
              required
            />
          </div>

          <div className="col-12">
            <TextField
              fullwidth
              label="Description"
              value={formData?.description ?? ""}
              onChange={handleChange}
              name="description"
              id="description"
              multiline
              required
              maxLength={250}
            />
          </div>

          <div className="col-12">
            <TextField
              fullwidth
              label="Site URL"
              value={formData?.site_url ?? ""}
              onChange={handleChange}
              name="site_url"
              id="site_url"
            />
          </div>

          <div className="col-12">
            <TextField
              fullwidth
              label="Due Date"
              value={formData?.due_date ?? ""}
              onChange={handleChange}
              name="due_date"
              id="due_date"
              type="date"
              required
              min={new Date().toISOString().split('T')[0]}
            />
          </div>

          <div className="col-12">
            <TextField
              label="Reference Document (Max Size: 5MB)"
              id="brochure"
              onChange={handleFileChange}
              accept=".pdf"
              name="brochure"
              type="file"
            />
          </div>

          <div className="col-12">
            <TextField
              label="Image (Max Size: 2MB)"
              id="image"
              onChange={handleFileChange}
              accept=".jpg,.jpeg,.png"
              name="image"
              type="file"
            />
          </div>

          <div className="col-12">
            <center>
              <button
                type="button"
                className="btn btn-dark mt-3"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </center>
          </div>
        </div>
      </div>
    </div>
  );
}
